import { Quiz, QuizAttempt } from '../../types'

interface QuizzesState {
  currentQuiz: Quiz
  previousAttempts: Array<QuizAttempt>
  currentAttempt: QuizAttempt
  finishedAttempt: QuizAttempt
}

const state: QuizzesState = {
  currentQuiz: {},
  previousAttempts: [],
  currentAttempt: {},
  finishedAttempt: {},
}

export { QuizzesState, state }
